import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid
} from 'recharts';
import { Paper, Typography, Skeleton } from '@mui/material';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const { label, clients } = payload[0].payload;

  return (
    <div style={{ backgroundColor: '#fff', padding: 10, border: '1px solid #ccc' }}>
      <strong>📅 {label}</strong>
      <div>🧑‍🤝‍🧑 Clientes: {clients}</div>
    </div>
  );
};

const ClientsPerMonthChart = ({ data, loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" gutterBottom>
        Clientes nuevos por mes (últimos 12 meses)
      </Typography>

      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis allowDecimals={false} />
            <Tooltip content={<CustomTooltip />} />
            <Line type="monotone" dataKey="clients" stroke="#1976d2" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default ClientsPerMonthChart;
